// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__TwOBk","rotate":"Spinner_rotate__j7157","path":"Spinner_path__UOuJu","dash":"Spinner_dash__VRb7j"};